/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { NO_MARGIN_BOTTOM } from '@constants';

import RelatedContentModal from '../RelatedContentModal';
import LanguageField from '../LanguageField';

const LanguageModal = ({
  visible,
  hide,
  onSubmit,
  eventId,
  title = 'Choose language',
  okText = 'ADD LANGUAGE',
  titleLevel,
}) => (
  <RelatedContentModal
    visible={visible}
    hide={hide}
    title={title}
    okText={okText}
    onSubmit={({ language }) => onSubmit(language)}
    titleLevel={titleLevel}
  >
    <LanguageField
      name="language"
      queryVariables={{ eventId }}
      style={NO_MARGIN_BOTTOM}
      rules={[{ required: true, message: 'Language is required' }]}
    />
  </RelatedContentModal>
);

export default LanguageModal;
